/* ==========================================================================
   EGM collection grid: "Load more" dell'ordinamento esauriti in fondo.
   Caricato da sections/main-collection-product-grid.liquid
   ========================================================================== */
/* "Load more" dell'ordinamento globale: mostra la tranche successiva di card
   gia presenti nella pagina. Listener delegato sul document, cosi funziona
   anche dopo che i filtri AJAX hanno sostituito #ProductGridContainer. */
if (!window.egmShowMoreInit) {
  window.egmShowMoreInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-egm-show-more]');
    if (!btn) return;
    e.preventDefault();

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var step = parseInt(btn.getAttribute('data-step'), 10) || 48;
    var hidden = grid.querySelectorAll('.egm-more-card');
    var firstRevealed = null;

    for (var i = 0; i < hidden.length && i < step; i++) {
      hidden[i].classList.remove('egm-more-card');
      if (!firstRevealed) firstRevealed = hidden[i];
    }

    /* Accessibilita: porta il focus sulla prima card appena mostrata */
    if (firstRevealed) {
      var link = firstRevealed.querySelector('a[href]');
      if (link) link.focus({ preventScroll: true });
    }

    if (!grid.querySelector('.egm-more-card')) {
      var wrap = btn.closest('.egm-show-more-wrap');
      if (wrap) wrap.hidden = true;
    }
  });
}

/* Il fast add to cart ora sta in assets/egm-fast-add.js (snippets/egm-fast-add-loader.liquid). */